import { imageFieldsFrag } from '@/service/fragments/imageFieldsFrag'
import { gql } from '@/service/gql'
import type { ResultOf } from 'gql.tada'
import { playableEntityFrag } from '@/service/fragments/playableEntityFrag'

// language=GraphQL
export const stationFieldsFrag = gql(
    `
        fragment stationFields on Station @_unmask {
            ...playableEntity
            id
            name
            images {
                ...imageFields                
            }
        }
    `,
    [imageFieldsFrag, playableEntityFrag]
)

export type StationFields = ResultOf<typeof stationFieldsFrag>
